
      import API from "!../../../../style-loader@4.0.0_webpack@5.94.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../style-loader@4.0.0_webpack@5.94.0/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../style-loader@4.0.0_webpack@5.94.0/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../style-loader@4.0.0_webpack@5.94.0/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../style-loader@4.0.0_webpack@5.94.0/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../style-loader@4.0.0_webpack@5.94.0/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/cjs.js!../../../../postcss-loader@8.1.1_postcss@8.5.1_typescript@5.7.3_webpack@5.94.0/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].use[2]!./lite-yt-embed.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../css-loader@7.1.2_webpack@5.94.0/node_modules/css-loader/dist/cjs.js!../../../../postcss-loader@8.1.1_postcss@8.5.1_typescript@5.7.3_webpack@5.94.0/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].use[2]!./lite-yt-embed.css";
       export default content && content.locals ? content.locals : undefined;
